import React from 'react'
import PropTypes from 'prop-types'

import styles from './index.css'

export default class Paper extends React.Component {
  
  static propTypes = {

  }

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className={styles.Paper} {...this.props}>
        {this.props.children}
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/Paper/index.jsx